export const queryKeys = {
  loans: "loans",
  user: "user",
  users: "users",
  branch: "branch",
  loanTypes: "loanTypes",
  checklist: "checklist",
  pending: "pending",
  approved: "approved",
  declined: "declined",
  summary: "summary",
  bank: "bank",
  roles: "roles",
  group: "group",
  audit: "audit",
  admin: "admin",
  loanType: "loanType",
  document: "document",
  allLoan: "allLoan",
  approval: "approval",
  approvalTransfer: "approvalTransfer",
  zones: "zones",
  collateralType: "collateralType",
  facilityType: "facilityType",
  security: "security",
  disbursementStep: "disbursementStep",
  query: "queried",
  offer: "Offer",
  pendingOffer: "pendingOffer",
  queryOffer: "queryOffer",
};
